<template>
  <div>
    <div class="input-group color-picker" ref="colorpicker">
      {{style_name}}
      <input type="text" class="form-control" v-model="colorValueLocal" @focus="showPicker()" autocomplete="new-password"
             @input="updateFromInput"/>
      <div class="input-group-addon color-picker-container">
        <div class="current-color" :style="'background-color: ' + style_color"
             @click="togglePicker()"></div>
        <chrome-picker :value="style_color" @input="updateFromPicker" v-if="displayPicker"/>
      </div>
    </div>
  </div>
</template>

<script>
  import {Chrome} from 'vue-color'
  import { mapGetters } from 'vuex'
  import * as utils from '@/utils/main_utils'

  export default {
    name: 'ColorPicker',
    components: {
      'chrome-picker': Chrome,
    },
    data() {
      return {
        colors: {
          hex: '#449EFF',
        },
        displayPicker: false,
        defaultColor: '#FF0000',
        colorValueLocal: this.style_color
      }
    },
    computed: {
      ...mapGetters(['defaultColors']),
    },
    mounted(){
      this.updateColors(this.colorValueLocal)
    },
    methods: {
      updateColors(color) {
        if (color.slice(0, 1) == '#') {
          this.colors = {
            hex: color
          };
        } else if (color.slice(0, 4) == 'rgba') {
          var rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(','),
          hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1);
          this.colors = {
            hex: hex,
            a: rgba[3],
          }
        } else if (color.slice(0, 3) == 'rgb') {
          var rgb = color.replace(/^rgb?\(|\s+|\)$/g, '').split(','),
          hexrgb = '#' + ((1 << 24) + (parseInt(rgb[0]) << 16) + (parseInt(rgb[1]) << 8) + parseInt(rgb[2])).toString(16).slice(1);
          this.colors = {
            hex: hexrgb
          }
        }
        this.$store.dispatch('updateCustomizationColor', {'color_name': this.style_name, 'color_value': this.colors.hex})
      },
      showPicker() {
        if (!this.frIsReadOnly) {
          document.addEventListener('click', this.documentClick);
          this.displayPicker = true;
        }
      },
      hidePicker() {
        document.removeEventListener('click', this.documentClick);
        this.displayPicker = false;
      },
      togglePicker() {
        this.displayPicker ? this.hidePicker() : this.showPicker();
      },
      updateFromInput() {
        this.updateColors(this.colorValueLocal);
      },
      updateFromPicker(color) {
        this.colors = color;
        if (color.rgba.a == 1) {
          this.colorValueLocal = color.hex;
        } else {
          this.colorValueLocal = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')';
        }
      },
      documentClick(e) {
        var el = this.$refs.colorpicker,
        target = e.target;
        if (el && el !== target && !el.contains(target)) {
          this.hidePicker()
        }
      }
    },
    watch: {
      colorValueLocal(val) {
        if (val!==undefined) {
          this.updateColors(val);
          this.$emit('input', val);
          let style_value = (val.slice(0, 3) === 'rgb') ? val : 'rgb('+utils.hexToRgb(val)+')'
          document.documentElement.style.setProperty('--' + this.style_name, style_value);
        }
      }
    },
    props: {
      style_name: {
        type: String,
      },
      style_color: {
        type: String,
      },
    },
  }
</script>

<style lang="scss">

  .input-group-addon {
    @include dir(rtl) {
      display: grid;
      grid-template-columns: auto 1fr;
      grid-template-rows: $px45;
      margin-right: $px10;
    }

  }

  .field-caption {
    @include dir(rtl) {
      text-align: right;
    }
  }

  .input-group.color-picker {
    margin: 0.4rem 0;
    .form-control {
      padding: 0.3rem;
      font-size: 0.7rem;
      width: 6rem;
      border-radius: $px4;
      border-color: black;
      color: black;
    }
    .vc-chrome{
      z-index: 1;
      position: fixed;
      right: 0;
    }
    .vc-chrome-body {
      z-index: 12;
      .vc-chrome-fields-wrap {
        .vc-chrome-fields:nth-child(2) {
          .vc-chrome-field:nth-child(4) {
            display: none;
          }
        }
        .vc-chrome-fields:nth-child(3) {
          .vc-chrome-field:nth-child(4) {
            display: none;
          }
        }
      }
      .vc-chrome-controls {
        .vc-chrome-sliders {
          .vc-chrome-alpha-wrap {
            display: none;
          }
          .vc-chrome-hue-wrap {
            margin: 10px 0 0 0;
          }

        }
      }
    }
  }

  .current-color {
    height: 100%;
    max-height: 2.4rem;
    min-width: 2.4rem;
    display: inline-block;
    border: 1px solid black;
    width: 16px;
    background-color: white;
    cursor: pointer;
    border-radius: 0.25rem;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: none;
  }
</style>